<template>
  <div :class="[data.cssClass]">
    <i
      :ref="tippyId"
      v-tippy="tippyConfig"
      class="b2b-grid__icon material-icons cursor-pointer"
      :title="tooltipContent"
      @show="restoreOriginalContent"
      @hidden="$emit('tooltip-closed', {id: itemId, content: noteContent, dirtyContent: dirtyContent})"
    >
      {{ data.value }}
      <pdl-badge v-if="data.hasNotification" qaid="sku-grid-note-badge" class="absolute left-0 top-0" />
    </i>

    <!-- Tooltip -->
    <div v-if="data.editable" :id="tippyId" v-tippy-html qaid="noteTooltip">
      <div class="cart-line-tooltip text-left p-1 max-w-xs">
        <div>
          <div class="section-header">
            <label class="font-medium" :for="rowId + '-input'" v-text="bp('addANote')"></label>

            <!-- Real Button -->
            <trek-button
              text
              small
              icon-only
              icon="clear"
              class="p-25 absolute top-0 right-0 mt-1 mr-1"
              aria-label="Close"
              @click="closeTooltip(noteId)"
            >
            </trek-button>
          </div>
          <div class="form-group mb-0">
            <textarea
              :id="rowId + '-input'"
              v-model="noteContent"
              class="form-control w-64 max-w-full"
              :maxlength="maxLength"
              rows="4"
              :placeholder="placeholderText"
              @input="updateContent"
            >
            </textarea>
            <div class="buttons buttons--right mt-1">
              <trek-button primary small qaid="add-note-button" @click="addNote" v-text="bp('addNote')"> </trek-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import {PdlBadge} from '@pedal/pdl-badge';

export default {
  components: {TrekButton, PdlBadge},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    baseProperties: {
      type: Array,
      default: () => [],
    },
    // need to refactor this so only one value is valid. #nomoretwovalueprops!
    /* eslint-disable */
    rowId: [String, Number],
    itemId: [String, Number],
    /* eslint-enable */
    maxLength: {
      type: Number,
      default: 0,
    },
    placeholderText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      noteContent: this.data.content,
      dirtyContent: this.data.content,
    };
  },

  computed: {
    noteId() {
      return `note-${this.rowId}`;
    },
    tippyId() {
      return `tippy_${this.rowId}_${this.itemId}`;
    },
    tippyConfig() {
      if (this.data.editable) {
        return {
          html: `#${this.tippyId}`,
          theme: 'light',
          interactive: true,
          sticky: true,
          trigger: 'click',
          reactive: true,
        };
      } else {
        return {
          theme: 'light',
          trigger: 'mouseenter focus',
        };
      }
    },
    tooltipContent() {
      return this.editable ? this.noteContent : this.data.content;
    },
  },

  mounted() {
    this.dirtyContent = this.data.content;
  },

  methods: {
    restoreOriginalContent() {
      this.noteContent = this.tooltipContent;
    },

    openTooltip() {
      let el = this.$refs[`tippy_${this.rowId}_${this.itemId}`];
      if (el && el._tippy) el._tippy.show();
    },

    closeTooltip() {
      let el = this.$refs[`tippy_${this.rowId}_${this.itemId}`];

      if (el && el._tippy) {
        el._tippy.hide();
      }
    },

    addNote() {
      this.$emit('note-added', {id: this.itemId, content: this.noteContent});
      this.dirtyContent = this.noteContent;
      this.closeTooltip(this.noteId);
    },

    updateContent() {
      this.data.content = this.noteContent;
    },
  },
};
</script>
